import axios from "axios";

// const BASE_URL = "https://cbzmjhrz5q.us-east-2.awsapprunner.com";
const BASE_URL = "https://dashboard-api.socialpawsapp.com";

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("admin_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem("admin_token");
      // window.location.href = "/";
    }

    return Promise.reject(error);
  },
);

export default apiClient;
